import React, { useState } from 'react';
import { CardNumberElement,CardExpiryElement,CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import {  Form, Button } from "react-bootstrap";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastwarning } from '../../Utils/Common';

const CheckoutForm = ({ inputsche,cartitems }) => {
  const [loading,setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  

const handleSubmit = async (e) => {
     e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);
    try {
        
        // Create payment intent
        let formData = new FormData();
       formData.append(
		  "amount",
		  (
		    (cartitems || [])
		      .reduce((total, item) => total + parseFloat(item.price || 0), 0)
		  ).toFixed(2)
		);
       formData.append('email', inputsche.email);
        formData.append('first_name', inputsche.first_name);
        formData.append('last_name', inputsche.last_name);
        formData.append('course_data', JSON.stringify(cartitems));
        formData.append('type', 'WebMasterClass');
        
        const paymentIntentResponse = await API.post('createPaymentIntentMasterclass', formData);
 
        if (paymentIntentResponse.data.status === false) {
            setLoading(false);
            gettoastwarning(paymentIntentResponse.data.message, '');
            return;
        }
 
        const clientSecret = paymentIntentResponse.data.data.clientSecret;
 
        // Confirm the payment
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: `${inputsche.first_name} ${inputsche.last_name}`,
                    email: inputsche.email,
                },
            },
        });
 
        if (result.error) {
            PaymentIntentFail(paymentIntentResponse.data.data.paymentIntentId, result.error.message);
            setLoading(false);
            gettoastwarning(result.error.message, '');
        } else {
            pay(paymentIntentResponse.data.data.paymentIntentId);
        }
 
    } catch (error) {
		setLoading(false);
        console.error(error);
		var msg='Payment Intent: '+error.message;
        gettoastwarning(msg, '');
    } finally {
        //setLoading(false);
    }
};
  
  function PaymentIntentFail(intent_id,message){
	 let formData = new FormData(); 
			formData.append('intent_id', intent_id);
			formData.append('message', message);
			API.post('payment_failed_master_class', formData)
				.then(response1 => {
					
				if(response1.data.status === false){
					
				}else{
				   
				}                  
			}).catch(error => {
				
			}); 
  }
  function pay(intent_id){
	  
	  let formData = new FormData(); 
		formData.append(
		  "grand_total",
		  (
		    (cartitems || [])
		      .reduce((total, item) => total + parseFloat(item.price || 0), 0)
		  ).toFixed(2)
		);
		formData.append('stripe_token', 'fgfg');
       formData.append('email', inputsche.email);
        formData.append('first_name', inputsche.first_name);
        formData.append('last_name', inputsche.last_name);
        formData.append('course_data', JSON.stringify(cartitems));
        formData.append('type', 'WebMasterClass');
		formData.append('intent_id', intent_id);
		API.post('order_book_for_web_master_class', formData)
			.then(response1 => {	
			if(response1.data.status === false){
				setLoading(false);
				gettoastwarning(response1.data.message,'');
			}else{
			   var order_number=response1.data.data.order_number;
			   window.location.href = `/order-completed-new?order_number=${order_number}`;
			}                  
		}).catch(error => {
			 setLoading(false);
			 var msg='Payment: '+error.message;
			 gettoastwarning(msg,'');
		}); 
  }

  return (
    <Form onSubmit={handleSubmit}>
		<div className="row g-3 mb-3">
		  <div className="col-md-12">
		 
			<Form.Group controlId="cardNumber">
			  <Form.Label>Card number</Form.Label>
			  <div className="form-control">
			  <CardNumberElement options={{
				disableLink: true,
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		<div className="row g-3 mb-3">
		  <div className="col-md-6">
			<Form.Group controlId="expiryDate">
			  <Form.Label>Expiration date</Form.Label>
			  <div className="form-control">
			  <CardExpiryElement options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		  <div className="col-md-6">
			<Form.Group controlId="cvv">
			  <Form.Label>CVC/CVV</Form.Label>
			  <div className="form-control ">
			  <CardCvcElement  options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		
		<Button type="submit" className="mt-4 w-100 ne">CONFIRM - €{
    (
      (cartitems || [])
        .reduce((total, item) => total + parseFloat(item.price || 0), 0)
    ).toFixed(2)
  }</Button>
		{loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
	  </Form>
  );
};

export default CheckoutForm;
